<mat-card class="selection-section">
  <!-- <div class="panel_sub_header">
      <span class="panel__header__title">   {{"CRC Pre & Post Shipment Observation List Setup" | translate | async}}</span>
  </div> -->
  <div class="select-observation-against">
    <div class="filter-select">
    
        <mat-form-field  class="filter-select" >
          <mat-select  [(ngModel)]="selectedInspectionType" [disabled]="HideCreateInspection" placeholder="{{ 'Inspection Types' | translate | async}}">
            <mat-option  [value]="0" > Select Inspection Type </mat-option>
              <mat-option  [value]="1" > Pre-shipment Inspection </mat-option>
              <mat-option  [value]="7" > Ready to Ship Inspection </mat-option>
              <mat-option  [value]="3" > Arrival Repairer Inspection </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="input-container">
          <span class="label">Select Inspection Date</span>
          <span class="input-icon input-icon--mat cursor-pointer" (click)="picker.open()"  style="padding: 7px 16px;
          background: #E4EAF0;
          font-size: 14px;">
              <i class="material-icons">date_range</i>
          </span>
          <input type="text" [matDatepicker]="picker" class="get-Input-date" 
                 [max]="maxDateForAction" placeholder="Choose a date"
                 [(ngModel)]="eventDate" 
                 readonly="readonly" style="color: black">
          <mat-datepicker #picker></mat-datepicker>
      </div>
      <button *ngIf="!HideCreateInspection" [disabled]="selectedInspectionType==0" mat-raised-button color="warn"  (click)="CreateNewFECRInspection()"> <i  class="material-icons"></i> {{"Create Inspection"|translate|async}}</button>
     


    </div>


   
    
  </div>
</mat-card>
<mat-card style="margin-top: 20px; margin-left: 2%;" *ngIf="selectedInspectionType>0 && inspectionId>0">
  <div class="panel_sub_header">
      <span class="panel__header__title" *ngIf="selectedInspectionType==1">   {{"Pre-shipment Inspection" | translate | async}}</span>
      <span class="panel__header__title" *ngIf="selectedInspectionType==7">   {{"Ready to Ship Inspection" | translate | async}}</span>
      <span class="panel__header__title" *ngIf="selectedInspectionType==3">   {{"Arrival Repairer Inspection" | translate | async}}</span>
  </div>
  
  <table class="table table--full-width table--striped">
  <thead>
    <tr>
      <th>{{'Description' | translate | async}}</th>
      <th></th>
      <th>{{'Image' | translate | async}}</th>
      <th>{{'Comment' | translate | async}}</th>
      <th>{{'Delete' | translate | async}}</th>
      <td><button mat-raised-button color="warn"  (click)="AddNewObservationList()"> <i  class="material-icons">add</i> {{"Add Observations"|translate|async}}</button> </td>
    </tr>
  </thead>
 <tbody *ngIf="observationLists?.length > 0"  >
    <tr *ngFor="let ob of observationLists">

      <td> {{ob.Title}} </td>
      <td>
        <i   class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;" 
         title="Edit Additional Observation" (click)="EditObservation(ob)" >
          create
        </i>
      </td>

      <td class="inspection-component-photo">
        <!-- <upload-photo   [comingFrom]="PopupEndPoint"  (onPhotoUpload)="reloadObservationPhoto(ob)" [ObservationListId]="ob.Id" ></upload-photo>-->
        <!-- <img *ngFor="let photo of ob.Images"  (click)="viewObservationListPhoto(ob,photo)" class="inspection-observation-photo" [src]="getImage(photo.Image)"  />  -->
     
        <!-- <photos-modal ></photos-modal> -->
        <photos-modal [FECRAdditionalObs]="ob" [FECRObsInspectionId]="ob.Id"  
        [comingFrom]="13"  (onPhotoUpload)="photoRecevied($event, ob)"></photos-modal>

      <span *ngFor="let inspectionImg of ob.Images">
        <img *ngIf="inspectionImg.Image !== '' && inspectionImg.Image !== null"
          (click)="ViewInspectionImage(ob,inspectionImg)" class="observation-image__photo"
          [src]="getImage(inspectionImg.Image)" />
          </span>
      </td>

     <td class="inspection-component-photo">
     
        <textarea  style="margin:0px;height: 60px;width: 100%;" class="form-textarea" rows="2"  [(ngModel)]="ob.Comment"   (focusout)="updateComment(ob.Comment, ob.Id,ob)">
        </textarea>
     </td>
      
      <td>
        <i   class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;"  title="Delete Additional Observation" (click)="OpenDeleteAdditionalObs(ob.Id)" >
          delete
        </i>
      </td>
    </tr>
  </tbody> 

  <div *ngIf="observationLists?.length == 0">{{ "Currently there is no observation list configured for this inspection and this equipment" | translate | async}}</div>
</table>
</mat-card>


